var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ninja-grid no-data-text=\"No rental items yet...\" grid-title=\"Rental Items\" doc-svc=\"vm.docSvc\" list=\"vm.docSvc.doc.rentalItems\" create-method=\"addRentalItem\" update-method=\"\" delete-method=\"removeRentalItem\" add-toggle=\"vm.sideTab.rentalItems\" fields=\"{name: {input: 'text', header: 'Rental Item', order: 10, width: 20, type: 'string'}, quantity: {input: 'text', header: 'Quantity', order: 20, width: 20, type: 'string'}, price: {input: 'text', header: 'Price', order: 30, width: 20, type: 'string'}  }\"></ninja-grid>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/events/contracts/tabs/tab-rentalItems.jade
// module id = 273
// module chunks = 0